const keys = {
    GET_EDUCATIONAL_POSTS: '/educational-posts', // coach_id , category_ids : []
    GET_EDUCATIONAL_POSTS_MARKED: '/educational-posts/marked', // coach_id , category_ids : []
    EDUCATIONAL_POSTS_STATUS_UPDATE: (id: string, status: 'view' | 'like' | 'mark') =>
        `/educational-posts/toggle/${id}/${status}`,
    POST_EDUCATIONAL_POST_SET_DURATION: (id: number) => `/educational-posts/${id}/set-duration`
};

export default keys;

